var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"carousel_image",attrs:{"src":_vm.src,"alt":_vm.alt,"position":_vm.position,"max-height":`${_vm.max_height}vh`,"max-width":`${_vm.max_width ? _vm.max_width : 50}vw`,"contain":_vm.contain},on:{"click":function($event){return _vm.$emit('click', true)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }